import { render, staticRenderFns } from "./StallionNotes.vue?vue&type=template&id=179a44df&"
import script from "./StallionNotes.vue?vue&type=script&lang=js&"
export * from "./StallionNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports